import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SB_URL;
const supabaseAnonKey = process.env.REACT_APP_SB_API_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Add more resilient settings
    flowType: 'pkce',
    debug: process.env.NODE_ENV === 'development'
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    },
    // Handle connection issues more gracefully
    reconnectAfterMs: (tries) => Math.min(tries * 1000, 30000)
  },
  // Add global error handling
  global: {
    headers: {
      'X-Client-Info': 'hustling-platform'
    }
  }
});
